// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"b46206ae","123":"4d334c1b","298":"65f8f359","787":"cda612ba","994":"d3e2d51f"}[chunkId] + ".chunk.js";
};